import { render, staticRenderFns } from "./Campu.vue?vue&type=template&id=f2bd2d18&"
import script from "./Campu.vue?vue&type=script&lang=js&"
export * from "./Campu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports